import { render, staticRenderFns } from "./course_customization.vue?vue&type=template&id=d9b53576&scoped=true&"
import script from "./course_customization.vue?vue&type=script&lang=js&"
export * from "./course_customization.vue?vue&type=script&lang=js&"
import style0 from "./course_customization.vue?vue&type=style&index=0&id=d9b53576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b53576",
  null
  
)

export default component.exports